module.exports = __webpack_public_path__ + "static/media/61D9VRkjPWL._AC_UX569_.19cd3c33.jpg";